var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "11", xl: "10" } },
            [
              !_vm.isUserAdmin
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-8",
                      attrs: { type: "error", outlined: "" },
                    },
                    [
                      _vm._v(
                        " You are not allowed to access auth failure diagnostics. "
                      ),
                    ]
                  )
                : _c(
                    "v-card",
                    {
                      staticClass: "mt-8 mb-8",
                      attrs: { loading: _vm.loading },
                    },
                    [
                      _c(
                        "template",
                        { slot: "progress" },
                        [
                          _c("v-progress-linear", {
                            attrs: {
                              color: "#006c27",
                              indeterminate: "",
                              height: "6",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-title",
                        { staticClass: "grey--text text--darken-2" },
                        [
                          _vm._v(" Auth Failures "),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: { color: "#006c27", dark: "" },
                              on: { click: _vm.reloadAll },
                            },
                            [_vm._v("Reload")]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                outlined: "",
                                color: "#b71c1c",
                                disabled: _vm.loading || _vm.deleting,
                              },
                              on: { click: _vm.openBulkDeleteDialog },
                            },
                            [_vm._v(" Bulk Delete ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c("div", { staticClass: "text-subtitle-2 mb-2" }, [
                            _vm._v("Signals (since process start)"),
                          ]),
                          _c(
                            "v-simple-table",
                            {
                              staticClass: "elevation-1 mb-6",
                              attrs: { dense: "" },
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [_vm._v("Error Code")]),
                                  _c("th", [_vm._v("Count")]),
                                  _c("th", [_vm._v("Last Seen")]),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                _vm._l(_vm.signals, function (item) {
                                  return _c("tr", { key: item.errorCode }, [
                                    _c("td", [_vm._v(_vm._s(item.errorCode))]),
                                    _c("td", [_vm._v(_vm._s(item.count))]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.formatDate(item.lastSeenAt))
                                      ),
                                    ]),
                                  ])
                                }),
                                0
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "text-caption grey--text mb-6" },
                            [
                              _vm._v(
                                " Process started: " +
                                  _vm._s(_vm.formatDate(_vm.processStartedAt)) +
                                  " "
                              ),
                            ]
                          ),
                          _c("v-divider", { staticClass: "mb-4" }),
                          _c("div", { staticClass: "text-subtitle-2 mb-3" }, [
                            _vm._v("Persisted Records"),
                          ]),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "datetime-local",
                                      label: "From",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.fromLocal,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "fromLocal", $$v)
                                      },
                                      expression: "filters.fromLocal",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "datetime-local",
                                      label: "To",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.toLocal,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "toLocal", $$v)
                                      },
                                      expression: "filters.toLocal",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.errorCodeOptions,
                                      label: "Error Codes",
                                      multiple: "",
                                      chips: "",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.errorCodes,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "errorCodes", $$v)
                                      },
                                      expression: "filters.errorCodes",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Request ID",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.requestId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "requestId", $$v)
                                      },
                                      expression: "filters.requestId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "OID",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.oid,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "oid", $$v)
                                      },
                                      expression: "filters.oid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Eligibility Reason",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.eligibilityReasonCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "eligibilityReasonCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "filters.eligibilityReasonCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Unresolved Reason",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.unresolvedReasonCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "unresolvedReasonCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "filters.unresolvedReasonCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex align-center",
                                  attrs: { cols: "12", md: "3" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        small: "",
                                        text: "",
                                        color: "#006c27",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setPresetHours(1)
                                        },
                                      },
                                    },
                                    [_vm._v("1h")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        small: "",
                                        text: "",
                                        color: "#006c27",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setPresetHours(24)
                                        },
                                      },
                                    },
                                    [_vm._v("24h")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        text: "",
                                        color: "#006c27",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setPresetHours(168)
                                        },
                                      },
                                    },
                                    [_vm._v("7d")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.triStateOptions,
                                      "item-text": "text",
                                      "item-value": "value",
                                      label: "Eligible User",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.isEligibleUser,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "isEligibleUser",
                                          $$v
                                        )
                                      },
                                      expression: "filters.isEligibleUser",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.triStateOptions,
                                      "item-text": "text",
                                      "item-value": "value",
                                      label: "User Group Member",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.isUserGroupMember,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "isUserGroupMember",
                                          $$v
                                        )
                                      },
                                      expression: "filters.isUserGroupMember",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.triStateOptions,
                                      "item-text": "text",
                                      "item-value": "value",
                                      label: "Admin Group Member",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.isAdminGroupMember,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "isAdminGroupMember",
                                          $$v
                                        )
                                      },
                                      expression: "filters.isAdminGroupMember",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.triStateOptions,
                                      "item-text": "text",
                                      "item-value": "value",
                                      label: "Beta Group Member",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.isBetaGroupMember,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "isBetaGroupMember",
                                          $$v
                                        )
                                      },
                                      expression: "filters.isBetaGroupMember",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.triStateOptions,
                                      "item-text": "text",
                                      "item-value": "value",
                                      label: "Internal Visibility",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value:
                                        _vm.filters.isInternalVisibilityMember,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "isInternalVisibilityMember",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "filters.isInternalVisibilityMember",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.triStateOptions,
                                      "item-text": "text",
                                      "item-value": "value",
                                      label: "Has Projection",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.hasProjection,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "hasProjection",
                                          $$v
                                        )
                                      },
                                      expression: "filters.hasProjection",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.triStateOptions,
                                      "item-text": "text",
                                      "item-value": "value",
                                      label: "Is Unresolved",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.isUnresolved,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "isUnresolved",
                                          $$v
                                        )
                                      },
                                      expression: "filters.isUnresolved",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex align-center justify-end",
                                  attrs: { cols: "12", md: "3" },
                                },
                                [
                                  _c("v-select", {
                                    staticClass: "mr-2",
                                    staticStyle: { "max-width": "160px" },
                                    attrs: {
                                      items: _vm.sortByOptions,
                                      label: "Sort By",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.sortBy,
                                      callback: function ($$v) {
                                        _vm.sortBy = $$v
                                      },
                                      expression: "sortBy",
                                    },
                                  }),
                                  _c("v-select", {
                                    staticStyle: { "max-width": "140px" },
                                    attrs: {
                                      items: _vm.sortDirectionOptions,
                                      label: "Direction",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.sortDirection,
                                      callback: function ($$v) {
                                        _vm.sortDirection = $$v
                                      },
                                      expression: "sortDirection",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { staticClass: "mb-3", attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex justify-end",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        text: "",
                                        color: "#006c27",
                                        disabled: _vm.loading || _vm.deleting,
                                      },
                                      on: { click: _vm.resetFilters },
                                    },
                                    [_vm._v(" Reset Filters ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "#006c27",
                                        dark: "",
                                        loading: _vm.loading,
                                        disabled: _vm.deleting,
                                      },
                                      on: { click: _vm.search },
                                    },
                                    [_vm._v(" Search ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.items,
                              loading: _vm.loading,
                              "items-per-page": _vm.pageSize,
                              "item-key": "id",
                              "hide-default-footer": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: `item.at`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "text-caption" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.formatDate(item.at))
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.actions`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            small: "",
                                            color: "#006c27",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDetail(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-eye-outline")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            small: "",
                                            color: "#b71c1c",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDeleteDialog(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-delete-outline")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c(
                            "v-row",
                            { staticClass: "mt-3", attrs: { align: "center" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-caption",
                                  attrs: { cols: "12", md: "4" },
                                },
                                [
                                  _vm._v(
                                    " Showing " +
                                      _vm._s(_vm.items.length) +
                                      " of " +
                                      _vm._s(_vm.total) +
                                      " records "
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex justify-end align-center",
                                  attrs: { cols: "12", md: "8" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        text: "",
                                        color: "#006c27",
                                        disabled: _vm.page <= 1 || _vm.loading,
                                      },
                                      on: { click: _vm.pageBack },
                                    },
                                    [_vm._v(" Previous ")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "mx-3 text-caption" },
                                    [
                                      _vm._v(
                                        "Page " +
                                          _vm._s(_vm.page) +
                                          " / " +
                                          _vm._s(_vm.maxPage)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        text: "",
                                        color: "#006c27",
                                        disabled:
                                          _vm.page >= _vm.maxPage ||
                                          _vm.loading,
                                      },
                                      on: { click: _vm.pageNext },
                                    },
                                    [_vm._v(" Next ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "1100" },
          model: {
            value: _vm.detailDialog,
            callback: function ($$v) {
              _vm.detailDialog = $$v
            },
            expression: "detailDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "text--secondary" },
                [
                  _vm._v(" Auth Failure Detail "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        text: "",
                        color: "#b71c1c",
                        loading: _vm.deleting,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openDeleteDialog(_vm.detail)
                        },
                      },
                    },
                    [_vm._v(" Delete ")]
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("ID:")]),
                        _vm._v(" " + _vm._s(_vm.detail.id || "-")),
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("Error:")]),
                        _vm._v(" " + _vm._s(_vm.detail.errorCode || "-")),
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("At:")]),
                        _vm._v(" " + _vm._s(_vm.formatDate(_vm.detail.at))),
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("Request ID:")]),
                        _vm._v(" " + _vm._s(_vm.detail.requestId || "-")),
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("UPN:")]),
                        _vm._v(" " + _vm._s(_vm.detail.upn || "-")),
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("OID:")]),
                        _vm._v(" " + _vm._s(_vm.detail.oid || "-")),
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("Status:")]),
                        _vm._v(" " + _vm._s(_vm.detail.status || "-")),
                      ]),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-center justify-space-between mb-2",
                            },
                            [
                              _c("div", { staticClass: "text-subtitle-2" }, [
                                _vm._v("JWT Header"),
                              ]),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    "x-small": "",
                                    text: "",
                                    color: "#006c27",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyText(_vm.jwtHeaderPretty)
                                    },
                                  },
                                },
                                [_vm._v("Copy")]
                              ),
                            ],
                            1
                          ),
                          _c("v-textarea", {
                            attrs: {
                              value: _vm.jwtHeaderPretty,
                              readonly: "",
                              outlined: "",
                              "auto-grow": "",
                              rows: "10",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-center justify-space-between mb-2",
                            },
                            [
                              _c("div", { staticClass: "text-subtitle-2" }, [
                                _vm._v("JWT Payload"),
                              ]),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    "x-small": "",
                                    text: "",
                                    color: "#006c27",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyText(_vm.jwtPayloadPretty)
                                    },
                                  },
                                },
                                [_vm._v("Copy")]
                              ),
                            ],
                            1
                          ),
                          _c("v-textarea", {
                            attrs: {
                              value: _vm.jwtPayloadPretty,
                              readonly: "",
                              outlined: "",
                              "auto-grow": "",
                              rows: "10",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Keep Until",
                              type: "datetime-local",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.retention.keepUntilLocal,
                              callback: function ($$v) {
                                _vm.$set(_vm.retention, "keepUntilLocal", $$v)
                              },
                              expression: "retention.keepUntilLocal",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex align-center",
                          attrs: { cols: "12", md: "8" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "#006c27",
                                dark: "",
                                loading: _vm.retention.loading,
                                disabled: !_vm.detail.id,
                              },
                              on: { click: _vm.updateRetention },
                            },
                            [_vm._v(" Update Retention ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.detailDialog = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "520" },
          model: {
            value: _vm.deleteDialog.visible,
            callback: function ($$v) {
              _vm.$set(_vm.deleteDialog, "visible", $$v)
            },
            expression: "deleteDialog.visible",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text--secondary" }, [
                _vm._v("Confirm Delete"),
              ]),
              _c("v-card-text", [
                _vm._v(" Delete auth failure record "),
                _c("strong", [_vm._v(_vm._s(_vm.deleteDialog.id || "-"))]),
                _vm._v("? "),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.deleting },
                      on: {
                        click: function ($event) {
                          _vm.deleteDialog.visible = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "#b71c1c",
                        dark: "",
                        loading: _vm.deleting,
                      },
                      on: { click: _vm.confirmDeleteSingle },
                    },
                    [_vm._v("Delete")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "620" },
          model: {
            value: _vm.bulkDeleteDialog,
            callback: function ($$v) {
              _vm.bulkDeleteDialog = $$v
            },
            expression: "bulkDeleteDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text--secondary" }, [
                _vm._v("Confirm Bulk Delete"),
              ]),
              _c("v-card-text", [
                _vm._v(" Delete records matching current filters? "),
                _c("div", { staticClass: "text-caption grey--text mt-2" }, [
                  _vm._v(
                    " About " +
                      _vm._s(_vm.total) +
                      " records currently match these filters. Final deleted count can differ. "
                  ),
                ]),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.deleting },
                      on: {
                        click: function ($event) {
                          _vm.bulkDeleteDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "#b71c1c",
                        dark: "",
                        loading: _vm.deleting,
                      },
                      on: { click: _vm.confirmBulkDelete },
                    },
                    [_vm._v("Delete")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackbar.color, timeout: "3500" },
          model: {
            value: _vm.snackbar.visible,
            callback: function ($$v) {
              _vm.$set(_vm.snackbar, "visible", $$v)
            },
            expression: "snackbar.visible",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackbar.text) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }